<template lang="pug">
  .reviews(v-if="reviews")
    .reviews__border.reviews__border--top
    .reviews__border.reviews__border--right
    .reviews__border.reviews__border--bottom
    .reviews__border.reviews__border--left
    .reviews__corner.reviews__corner--tl
    .reviews__corner.reviews__corner--tr
    .reviews__corner.reviews__corner--bl
    .reviews__corner.reviews__corner--br
    .reviews__decor-top
    .reviews__decor-bottom
    .reviews__decor-left
    .reviews__title(v-if="h1") {{h1}}
    .reviews__content
      .reviews__items(v-if="reviewsItems && reviewsItems.items")
        .reviews__item(v-for="item in reviewsItems.items", :key="item.id")
          .reviews__item-img-wr(:data-src="item.img")
            img.reviews__item-img.reviews__item-img--hide(:src="item.img")
          .reviews__item-right
            .reviews__item-name(v-if="item.name") {{item.name}}
            .reviews__item-date(v-if="item.date") {{item.date}}
            .reviews__item-text(v-if="item.text") {{item.text}}
            a.reviews__item-link(v-if="item.link && item.link.href", :href="item.link.href", target="_blank") Ссылка на источник
              .reviews__item-link-title(v-if="item.link.title") {{item.link.title}}
      button.reviews__items-more(v-if="more", @click="loadMoreItems")
        SvgIcon(name="recycle" width="25" height="25" class="reviews__items-more-loader")
        SvgIcon(name="arrow-down" width="12" height="7" class="reviews__items-more-ico")
        .reviews__items-more-text Еще...

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/reviews/reviews.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  name: 'Reviews',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      reviews: null,
      reviewsItems: null,
      count: 0,
      perPage: 0,
      more: false,
      ps: null
    }
  },

  components: {
    SvgIcon
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadReviewsPage', params => {
      this.request(params.url);
    });

    EventBus.$on('loadReviewsPageInside', params => {
      this.requestInside(params);
    });
  },

  methods: {
    request(url) {
      this.req('ReviewsPage:getReviewsPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.reviews = res.content;
        }

        this.requestInside();
      }, 'reviews');
    },

    requestInside() {
      this.count = 0;
      let count = this.count;

      if(!this.reviews) {
        this.request('/otzivy');
      }
      else {
        this.req('ReviewsPage:getReviewsPageItems', {count}, res => {
          if(this.checkProperty(res.content)) {
            this.reviewsItems = res.content;
            this.perPage = this.reviewsItems.items.length;
            this.more = res.content.more;
          }

          this.$nextTick(() => {
            this.imgPreloader('reviews__item-img-wr', 'reviews__item-img', '', 250);
            this.initScroll();
          });
        }, '', 'localPageRequest');
      }
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.reviews__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        const container = document.querySelector('.reviews__content');
        container.scrollTop = 0;
        this.ps.update();
      }
    },

    loadMoreItems() {
      this.count = this.count + this.perPage;
      let count = this.count;

      $('.reviews__items-more').addClass('reviews__items-more--loading');

      this.req('ReviewsPage:getReviewsPageItems', {count}, res => {
        if(this.checkProperty(res.content)) {
          this.reviewsItems.items = this.reviewsItems.items.concat(res.content.items);
          this.more = res.content.more;
        }

        this.$nextTick(() => {
          this.imgPreloader('reviews__item-img-wr', 'reviews__item-img', '', 250);
          this.ps.update();

          setTimeout(() => {
            $('.reviews__items-more').removeClass('reviews__items-more--loading');
          }, 500);
        });
      }, '', 'localPageRequest');
    }

    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
